import { API } from "../axios/API";

export const tipoEtapasService = {
  async getAllTipoEtapas(grupo) {
    const resp = await API.get("/tipo-etapas", { grupo });
    return resp?.data;
  },
  async getTipoEtapas(grupo) {
    const resp = await API.post("/tipo-etapas", { grupo });
    return resp?.data;
  },
  async updateTipoEtapas(data) {
    const resp = await API.put("/tipo-etapas", data);
    return resp?.data;
  }
};